import { render, staticRenderFns } from "./BarCodeField.vue?vue&type=template&id=2f23608c&"
import script from "./BarCodeField.vue?vue&type=script&lang=js&"
export * from "./BarCodeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports